import React, {ReactElement} from 'react';
import block from 'bem-cn-lite';

import './Layout.scss';

const b = block('Layout');

const Header: React.FC = () => null;
const Content: React.FC = () => null;
const Footer: React.FC = () => null;

export interface LayoutProps {
    noHeader?: boolean;
    noFooter?: boolean;
    type?: 'doc';
    children: ReactElement[];
}

export default class Layout extends React.Component<LayoutProps> {
    static Header = Header;
    static Content = Content;
    static Footer = Footer;

    render() {
        const {noHeader, noFooter, type, children} = this.props;
        let header, content, footer;

        React.Children.forEach(children, (child) => {
            switch (child.type) {
                case Header:
                    header = child.props.children;
                    break;
                case Content:
                    content = child.props.children;
                    break;
                case Footer:
                    footer = child.props.children;
                    break;
            }
        });

        return (
            <div className={b({'no-footer': noFooter, type})}>
                {!noHeader && <div className={b('header')}>{header}</div>}
                <div className={b('body')}>
                    <div className={b('content')}>{content}</div>
                </div>
                {!noFooter && <div className={b('footer')}>{footer}</div>}
            </div>
        );
    }
}
